<template>
  <div>
    <!-- 检索条件 -->
    <el-form class="radius_bg" :model='searchCondition' inline size='mini' @submit.native.prevent style="display:flex">
      <el-form-item>
        <CategoryCascader :identify='`product`' @cascaderChange='cascaderChange' />
      </el-form-item>
      <el-form-item>
        <el-input placeholder='商品名称' v-model='searchCondition.title' @change='handleQuery' clearable />
      </el-form-item>
      <el-form-item>
        <el-select v-model='searchCondition.status' placeholder='审核状态' @change='handleQuery' clearable>
          <el-option v-for='item in options' :key='item.value' :label='item.label' :value='item.value'></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model='searchCondition.leader_id' filterable
                   v-if="userPermissions.indexOf('live-product-scope-all') > -1" allow-create
                   placeholder='负责人'
                   clearable
                   @change='changeLeader'>
          <el-option :label='`${item.label} (${item.total})`' :value='item.value' v-for='item in leaderList'
                     :key='item.value'></el-option>
        </el-select>
        <span v-else> 负责人：{{ userInfo.nickname }} </span>
      </el-form-item>
      <el-form-item>
        <el-input v-model='searchCondition.platform_name' clearable placeholder='可播平台' @change='handleQuery' />
      </el-form-item>
      <el-form-item>
        <el-input v-model='searchCondition.contact' clearable placeholder='提交人' @change='handleQuery' />
      </el-form-item>
      <el-form-item>
        <el-input placeholder='产品产地' v-model='searchCondition.origin_place' @change='handleQuery' clearable />
      </el-form-item>
      <el-form-item>
        <el-button type='primary' icon='el-icon-search' @click='handleQuery' :disabled='loading' :loading='loading'>搜索
        </el-button>
      </el-form-item>
      <el-form-item>
        <span class='el-icon-info' style='font-weight: lighter;font-size: 0.9em;color: red;cursor: pointer'
              title='产品手卡导出请到《产品库》页面进行导出'></span>
      </el-form-item>
      <el-form-item v-if='userPermissions.indexOf("live-product-merchant-brand") > -1' style='margin-left:auto'>
        <el-button round type='primary' @click='handleBrand'>商家品牌</el-button>
      </el-form-item>
    </el-form>
    <!-- 表格 -->
    <div class='audit-table default-table radius_bg'>
      <el-table :data='auditData' highlight-current-row
                @sort-change='changeTableSort' :row-class-name='showErr'>
        <el-table-column type='index' label='序号' align='center' fixed='left'></el-table-column>
        <el-table-column label='录入时间' prop='created_at' width='100' align='center' sortable='custom' fixed='left'>
          <template slot-scope='{ row }'>
            <span :title="`审核时间：${row.check_time||''}`">{{ $utils.parseTime(row.created_at, '{y}-{m}-{d}') }}</span>
          </template>
        </el-table-column>
        <el-table-column label='产品图' width='70' align='center' fixed='left'>
          <template slot-scope='{ row }'>
            <img v-if="row.is_sec_kill==='Y'" src='@/assets/icons/seckill.png' alt=""
                 style="position: absolute;top: 0px;left: -10px;z-index: 2;width: 30px; transform: rotate(-20deg)"/>
            <product-image :image-url='row.cover_url' style='width: 40px; height: 40px' />
          </template>
        </el-table-column>
        <el-table-column label='商品名称' prop='title' width='150' align='center' :show-overflow-tooltip='true'
                         fixed='left'>
          <template slot-scope='{ row }'>
            <span>{{ row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column label='秒杀品' width='70' align='center'>
          <template v-slot="{row:{is_sec_kill}}">
            {{ is_sec_kill === 'Y' ? '是' : '否'}}
          </template>
        </el-table-column>
        <el-table-column align='center' label='规格' min-width='100' prop='spec_name'
                         show-overflow-tooltip></el-table-column>
        <el-table-column align='center' label='季节性' min-width='100' prop='used_season'
                         show-overflow-tooltip></el-table-column>
        <el-table-column align='center' label='色号/香型' min-width='100' prop='spec_color'
                         show-overflow-tooltip></el-table-column>

        <el-table-column label='类目' prop='category_id' min-width='100' align='center' sortable='custom'>
          <template slot-scope='{ row }'>
            <span>{{ row.categoryAll || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label='可播平台' prop='platform_name' min-width='120' align='center'>
          <template slot-scope='{row}'>
            <span>{{ String(row.platform_name) || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column align='center' header-align='center' label='合作方式' min-width='110' prop='mode'
                         sortable='custom'>
          <template slot-scope='{ row }' v-if='row.mode'>
            <span>{{ row.mode.display_name || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label='日常价(元)' align='center' min-width='80'>
          <template slot-scope='{ row }'>
            <span>{{ row.price || '/' }}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label='直播价(元)' align='center' min-width='80'>
          <template slot-scope='{ row }'>
            <span>{{ row.lb_price || '/' }} </span>
          </template>
        </el-table-column>
        <el-table-column label='赠品/其他' prop='gift' align='center' min-width='120' show-overflow-tooltip>
          <template slot-scope='{ row }'>
            <span>{{ row.gift || '/' }} </span>
          </template>
        </el-table-column>
        <el-table-column label='线上佣金(%)' prop='online_cmn' align='center' min-width='120' sortable='custom'>
          <template slot-scope='{ row }'>
            <span class='rate'>{{ row.online_cmn || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label='线下佣金(%)' prop='offline_cmn' align='center' min-width='120' sortable='custom'>
          <template slot-scope='{ row }'>
            <span class='rate'>{{ row.offline_cmn || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label='负责人' prop='leader_id' align='center' min-width='100' sortable='custom'>
          <template slot-scope='{ row }'>
            <span>{{ row.leader_name || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label='备注信息' prop='remark' align='center' min-width='140' show-overflow-tooltip>
          <template slot-scope='{ row }'>
            <span>{{ row.remark || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label='店铺名称' prop='company_name' align='center' min-width='100' show-overflow-tooltip>
          <template slot-scope='{ row }'>
            <span>{{ row.company_name || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label='提交人' prop='contact' align='center'></el-table-column>
        <el-table-column label='审核状态' prop='status' align='center' width='90' fixed='right'>
          <template slot-scope='{ row }'>
            <el-tag v-if='row.status == 1'>待审核</el-tag>
            <el-tag type='success' v-else-if='row.status == 2'>审核通过</el-tag>
            <el-tag type='info' v-else>审核拒绝</el-tag>
          </template>
        </el-table-column>
        <el-table-column label='拒绝原因' prop='refuse_reason' header-align='center' show-overflow-tooltip>
          <template slot-scope='{ row }'>
            <span>{{ row.refuse_reason }}</span>
          </template>
        </el-table-column>
        <el-table-column label='操作' align='center' fixed='right'>
          <template slot-scope='{ row }'>
            <el-button size='default' type='text' @click='handleEdit(row)' class='el-icon-s-claim'>详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination :hidden='total === 0' :background='true' :total.sync='total' :page.sync='pageData.current_page'
                  :limit.sync='pageData.page_size' @pagination='getList' />
    </div>

    <!-- 审核详情 -->
    <AuditShow ref='refAuditShow'  @close='getList'  />

    <BusinessBrand :visible.sync='brandVisible' @close='brandVisible = false'></BusinessBrand>
  </div>
</template>

<script>
import CategoryCascader from '@/pages/category/components/CategoryCascader'
import ProductImage from '../../ProductImage.vue'
import { mapGetters } from 'vuex'
import AuditShow from './AuditShow.vue'
import BusinessBrand from '@/pages/lb/product/BusinessBrand.vue'

export default {
  name: 'ProductAuditCosmeticIndex',
  components: {
    CategoryCascader,
    ProductImage,
    AuditShow,
    BusinessBrand
  },
  computed: {
    ...mapGetters(['userPermissions', 'userInfo'])
  },
  data() {
    return {
      searchCondition: {
        leader_id: null,
        category_id: null,
        title: null,
        status: null,
        category_2_id: null,
        check_err: null,
        platform_name: null,
        contact: null,
        origin_place: null
      },
      options: [
        { value: 1, label: '待审核' },
        { value: 2, label: '审核通过' },
        { value: 3, label: '审核拒绝' }
      ],
      auditData: [],
      total: 0,
      pageData: { page_size: 15, current_page: 1 },
      orderSort: { id: 'desc' },
      loading: false,
      leaderList: [],
      brandVisible: false
    }
  },
  methods: {
    handleEdit(row) {
      this.$refs['refAuditShow'].show(row.id)
    },
    handleQuery() {
      this.pageData.current_page = 1
      this.getList()
    }
    ,
    async getOptions() {
      //get 负责人列表
      this.leaderList = await this.$api.productCheckLeaders()
    }
    ,
    //获取表单数据
    async getList() {
      this.loading = true
      this.auditData = []
      let searchCondition = this.handleSearchCondition()
      if (this.userPermissions.indexOf('live-product-scope-all') === -1) {
        searchCondition.leader_id = this.userInfo.id
      }
      Object.assign(searchCondition, this.pageData, { order: this.orderSort })
      searchCondition.c_type = 1
      const { list, page_info } = await this.$api.getProductAuditList(searchCondition)
      this.auditData = list || []
      this.pageData.current_page = page_info.current_page || 1
      this.pageData.page_size = page_info.page_size || 1
      this.total = page_info.total
      this.loading = false
    },
    changeTableSort({ prop, order }) {
      const orderSort = {}
      if (order) {
        orderSort[prop] = order === 'descending' ? 'desc' : 'asc'
      }
      this.orderSort = orderSort
      this.handleQuery()
    },
    //处理搜索条件
    handleSearchCondition() {
      const keys = ['category_id', 'category_2_id', 'title', 'leader_id', 'platform_name', 'contact', 'origin_place', 'check_err', 'status']
      const cond = {}
      keys.forEach(k => { if (this.searchCondition[k]) cond[k] = this.searchCondition[k] })
      return cond
    }
    ,
    changeLeader(v) {
      this.searchCondition.leader_id = v || null
      this.handleQuery()
    }
    ,
    cascaderChange(v) {
      this.searchCondition.category_id = null
      this.searchCondition.category_2_id = null
      if (v.length) {
        this.searchCondition.category_id = v[0]
        if (v.length === 2) {
          this.searchCondition.category_2_id = v[1]
        }
      }
      this.handleQuery()
    },
    handleBrand() {
      this.brandVisible = true
    },
    showErr({ row }) {
      if (row.status === 2 && !row.product_id)
        return 'err-info'

      return ''
    }


  },
  created() {
    if (this.userPermissions.indexOf('live-product-scope-all') > -1) {
      this.getOptions()
    }

    this.getList()
  }
}
</script>

<style lang="scss" scoped>
@import "@/pages/lb/style/main.scss";

</style>

